/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Public_FallbackInputs */



/**
* | output |
* | --- |
* | "Moved back to the shared bot after a plan change" |
*
* @param {Activity_Public_FallbackInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_public_fallback = /** @type {((inputs?: Activity_Public_FallbackInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Public_FallbackInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер вернулся на общего бота после смены тарифа")
	return /** @type {LocalizedString} */ ("Moved back to the shared bot after a plan change")
});